import { Component } from '@angular/core';
import { NavItem } from '@shared/interfaces/nav/nav-item';
import { settingsNavItem } from '@views/settings/settings.nav-item';
import { HeaderComponent } from '@shared/components/header/header.component';
import { Router, RouterOutlet } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UserService } from '@app/core/services/user.service';
import { HeaderService } from '@app/core/services/header.service';
import { InitialsPipe } from '@shared/pipes/initials.pipe';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { roleTableConfig } from '@shared/table-configs/settings/role.table';
import { LogOut } from 'lucide-angular';

@Component({
  selector: 'app-settings-overview',
  imports: [
    HeaderComponent,
    RouterOutlet,
    TranslatePipe,
    InitialsPipe,
    TableComponent,
  ],
  templateUrl: './settings-overview.component.html',
  styleUrl: './settings-overview.component.css'
})
export class SettingsOverviewComponent {
  public settingsMenu: NavItem[] = settingsNavItem;
  public tableConfig: TableConfig<any> = roleTableConfig;
  public tableRoles: any[] = [];

  constructor(
    public readonly userService: UserService,
    private readonly headerService: HeaderService,
    private readonly router: Router,
    private readonly translateService: TranslateService,
  ) {
    this.headerService.setActions(
      [{ id: 'logout', title: 'settings.logout', icon: LogOut }],
      { logout: () => this.logOut() },
    );

    const roles = this.userService.user()?.roles;
    if (roles?.length) {
      this.tableRoles = [...roles]
        .sort((a: string, b: string) => (a > b ? 1 : -1))
        .map((role: string) => ({
          role,
          description: this.translateService.instant(`role.${role.toLowerCase()}.description`),
        }));
    }
  }

  public logOut(): void {
    this.router.navigate(['/auth/logout']);
  }
}
